import { render, staticRenderFns } from "./RolePermissionComponent.vue?vue&type=template&id=57fd0cfa&scoped=true&"
import script from "./RolePermissionComponent.vue?vue&type=script&lang=js&"
export * from "./RolePermissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissionComponent.vue?vue&type=style&index=0&id=57fd0cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fd0cfa",
  null
  
)

export default component.exports